import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import lodash from 'lodash'

import '../../styles/lib/calendar.scss';
import { submitBookingInfo } from '../../state/actions/service';

function getDateComponent(date) {
  return moment(date).format("YYYY-MM-DD");
}

function group(list, keySelector) {
  const results = {};
  list.forEach(x => {
    const key = keySelector(x);
    results[key] = results[key] || [];
    results[key].push(x);
  });
  return results;
}

function DynamicBookingCalendar({ schedules }) {

  if (!schedules || schedules.length === 0)
    throw Error("Must provide at least one schedule for a calendar")

  const groupedSchedules = group(schedules, (x) => x.service_date);

  const getDefaultSlotForDate = (date) => {
    return lodash.orderBy(groupedSchedules[getDateComponent(date)], x => x.name)[0];
  };

  const isCalendarDisabled = (date) => {
    const dateComp = getDateComponent(date);
    return !groupedSchedules[dateComp];
  };

  const onDateUpdateHandler = (date) => {
    onDateChange(date);
    onSlotChange(getDefaultSlotForDate(date))
  };

  const allAvailableDatesSorted = Object.keys(groupedSchedules).sort();
  const initialDate = moment(allAvailableDatesSorted[0]).toDate();
  const initialSlot = getDefaultSlotForDate(initialDate);

  const [date, onDateChange] = useState(initialDate);
  const [selectedSlot, onSlotChange] = useState(initialSlot);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(submitBookingInfo({ date, service_slot_id: selectedSlot?.id, service_slot_name: selectedSlot?.name }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, selectedSlot]);

  useEffect(() => {
    if (date) {
      date.setHours(date.getHours() + 20); // DISCLAIMER: this is atrocious. I did not write it. It's simply a legacy from the previous booking calendar. Fixing it properly would ideally involve fixing the API as well to not use a timestamp but an actual date. No timezone should be involved here.
      dispatch(submitBookingInfo({ date, service_slot_id: selectedSlot?.id, service_slot_name: selectedSlot?.name }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const availableServiceSlots = date ? (groupedSchedules[getDateComponent(date)] ?? []) : [];
  const sortedServiceSlots = lodash.orderBy(availableServiceSlots, x => x.name);

  return (
    <div>
      <label className="input-label calendar-label">Välj dag och tid för inlämning.</label>
      <Calendar
        defaultView="month"
        next2Label=""
        locale="sv"
        showNeighboringMonth={false}
        prev2Label=""
        tileDisabled={({ date }) => isCalendarDisabled(date)}
        formatShortWeekday={(_, date) => ['S', 'M', 'T', 'O', 'T', 'F', 'L'][date.getDay()]}
        onChange={onDateUpdateHandler}
        value={date}
      />
      <div className="row">
        {sortedServiceSlots.map((slot) => {
          return (
            <ServiceSlot
              key={slot.id}
              slot={slot}
              isSelected={selectedSlot?.id === slot.id}
              onChange={onSlotChange}
            />
          );
        })}
      </div>
      <hr className="line" />
    </div>
  );
}

function ServiceSlot({ slot, isSelected, onChange }) {
  return (
    <div
      className={`col service-slot ${isSelected && 'service-slot-active'}`}
      onClick={() => onChange(slot)}
    >
      {slot.name}
    </div>
  );
}

export default DynamicBookingCalendar;
